<template>
    <div :class="['risk-maintenance-id-cell', { 'risk-maintenance-id-cell__warning-label': showWarning }]">
        <span class="risk-maintenance-id-cell__ids">
            <span
                v-for="(item, index) in idLinks"
                :key="index"
            >
                <a
                    v-if="item.href"
                    :href="item.href"
                    class="risk-maintenance-id-cell__link"
                    rel="noopener noreferrer"
                    target="_blank"
                >{{ item.id }}</a>
                <template v-else>{{ item.id }}</template><span v-if="index < idLinks.length - 1">, </span>
            </span>
            <template v-if="idLinks.length === 0">-</template>
        </span>
        <pui-icon
            v-if="showWarning"
            :id="`tooltip-target-risk-id-${rowId}`"
            icon-color="#fd7e14"
            icon-name="warning-circle"
        />
        <b-tooltip
            v-if="showWarning"
            :target="`tooltip-target-risk-id-${rowId}`"
            custom-class="hover-table"
            triggers="hover"
        >
            Some of the fields in this budget request have different values in MSP/PT Risk.
        </b-tooltip>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ICellRendererParams } from 'ag-grid-community';
import { MtpStatus } from '~/utils/interfaces';
import { getExternalItemDeepLink } from '~/utils/external-item-deep-link';

@Component({})
export default class RiskMaintenanceIdCellComponent extends Vue {
    private params?: ICellRendererParams;

    /** SSRM + nested `field` sometimes leaves `params.value` empty; read from row data too. */
    private get rawRiskOpportunityId(): string {
        const p = this.params;
        if (!p) {
            return '';
        }
        const fromValue = p.value;
        if (fromValue != null && String(fromValue).trim() !== '') {
            return String(fromValue);
        }
        const fromRow = p.data?.currentMtpPlanning?.riskOpportunityId;
        if (fromRow != null && String(fromRow).trim() !== '') {
            return String(fromRow);
        }
        return '';
    }

    private get parsedIds(): string[] {
        const raw = this.rawRiskOpportunityId;
        if (raw.trim() === '') {
            return [];
        }
        return raw
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);
    }

    private get idLinks(): { id: string; href: string | null }[] {
        return this.parsedIds.map((id) => ({ id, href: getExternalItemDeepLink(id) }));
    }

    private get rowId(): string | number {
        return this.params?.data?.id ?? 'row';
    }

    private get showWarning(): boolean {
        const planning = this.params?.data?.currentMtpPlanning;
        return planning?.hasDifferences && planning?.mtpStatus !== MtpStatus.REVIEWED;
    }
}
</script>

<style scoped lang="scss">
.risk-maintenance-id-cell {
  display: flex;
  align-items: center;
  gap: 6px;

  .risk-maintenance-id-cell__link {
    position: relative;
    z-index: 1;
    color: #007bff;
    text-decoration: underline;
    cursor: pointer;
  }

  .risk-maintenance-id-cell__link:hover {
    color: #0056b3;
  }

  &.risk-maintenance-id-cell__warning-label .risk-maintenance-id-cell__link {
    color: #fd7e14;
  }

  &.risk-maintenance-id-cell__warning-label .risk-maintenance-id-cell__link:hover {
    color: #dc6502;
  }
}
</style>
